export const GET_ACTIVE_POPUPS_QUERY_KEY = 'GET_AVAILABLE_POPUPS';
